import { useGetAlarmEventsQuery } from '@/api/alarms.api'
import { PAGINATION } from '@/constants/pagination'
import { TIME } from '@/constants/time'
import { useAuthStore } from '@/store/auth.store'

/**
 * Live count of active alarms, for the sidebar badge. Polls as a fallback;
 * Stage 7 layers WebSocket alarm events on top to update it in real time.
 * Requests a single row — only the pagination total is needed.
 */
export function useAlarmCount(): number {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const { data } = useGetAlarmEventsQuery(
    { status: 'active', page: PAGINATION.DEFAULT_PAGE, pageSize: 1 },
    { skip: !isAuthenticated, pollingInterval: TIME.ALARM_REFRESH_MS },
  )
  return data?.pagination.total ?? 0
}
